import { Link } from "wouter";

import { ArrowRight, Briefcase } from "lucide-react";

import { CoverArt } from "../../components/cards";
import { LocationPin } from "../../components/LocationPin";
import { Badge } from "../../components/ui/kit";

import { formatRelativeTime } from "../../lib/relativeTime";

import { useI18n } from "../../lib/i18n";

import type { RelatedJob } from "./model";

export function RelatedJobs({ jobs }: { jobs: RelatedJob[] }) {
  const { t } = useI18n();
  return (
    <section className="card p-3">
      <div className="flex items-center justify-between gap-3 px-2 pb-3">
        <h2 className="font-bold text-navy text-lg">{t("detail.job.similarJobs", "Similar Jobs")}</h2>
        <Link href="/marketplace?tab=Jobs" className="inline-flex items-center gap-1 text-sm font-semibold text-blue-700 hover:text-blue-900">{t("common.viewAll", "View all")} <ArrowRight className="w-4 h-4" /></Link>
      </div>
      {jobs.length > 0 ? (
        <div className="grid gap-2 sm:grid-cols-3">
          {jobs.map((job) => (
            <Link key={job.id} href={`/j/${encodeURIComponent(job.id)}`} className="min-w-0 rounded-lg border border-line p-3 hover:border-blue-300 transition-colors">
              <div className="h-14 w-14 overflow-hidden rounded-md bg-navy-50 mb-2"><CoverArt src={job.coverImage} alt="" Icon={Briefcase} /></div>
              <h3 className="font-bold text-navy text-sm line-clamp-2">{job.title}</h3>
              <p className="text-xs text-mut mt-1 truncate">{job.company}</p>
              <p className="text-xs text-mut mt-1 flex items-center gap-1"><LocationPin className="w-3.5 h-3.5" />{job.city}</p>
              <p className="text-xs text-mut mt-1 flex items-center gap-1"><Briefcase className="w-3.5 h-3.5" />{job.type || "Job"}</p>
              <div className="flex flex-wrap gap-1 mt-2">{Array.isArray(job.tags) && job.tags.slice(0, 2).map((tag) => <Badge key={tag}>{tag}</Badge>)}</div>
              <p className="font-bold text-navy text-sm mt-3">{job.salary || "Negotiable"}</p>
              <p className="text-xs text-mut mt-1">{formatRelativeTime(job.createdAt, job.posted)}</p>
            </Link>
          ))}
        </div>
      ) : <p className="text-sm text-mut px-2 pb-2">{t("detail.job.noSimilar", "No similar jobs are available right now.")}</p>}
    </section>
  );
}
